import useSWR from 'swr'
import { dashboardService } from '@/api/services/dashboard.service'

export const useDashboard = (workspaceId: number | undefined) => {
  return useSWR(
    workspaceId ? `dashboard:${workspaceId}` : null,
    () => dashboardService.getDashboard(workspaceId!),
  )
}
